import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-avi-file-icon',
  templateUrl: './doc-format-avi-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatAviFileIconComponent {}
